import apiClient from './client';

export const IcdNotCoveredAxiosInstance = apiClient;